module.exports = __webpack_public_path__ + "img/open_edition_giclee.81df6a29.jpg";